import Component from '@glimmer/component';
import { on } from '@ember/modifier';
import { service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import t from 'ember-intl/helpers/t';
import { Section } from 'tio-ui/components/layout';
import Button from 'tio-ui/components/button';
import { PhCheckCircle } from 'ember-phosphor-icons';

interface WhatHappensNextSignature {
  Args: {
    // Host app's questionnaire route (shared component — supplied by the host).
    questionnaireRoute: string;
  };
  Element: HTMLElement;
}

export default class StrategyFinder0726WhatHappensNext extends Component<WhatHappensNextSignature> {
  @service declare router: RouterService;

  // Mirrors the Strategy Finder "what happens next" card; the CTA re-runs the
  // questionnaire on whichever host app rendered it.
  goToForm = () => {
    this.router.transitionTo(this.args.questionnaireRoute);
  };

  <template>
    <Section data-test-sf-0726-what-next ...attributes>
      <:header>{{t "strategy_finder_0726.what_next.title"}}</:header>
      <:body>
        <ul class="space-y-2 mb-4">
          <li class="tio-row gap-2 items-start">
            <PhCheckCircle class="tio-fg-success shrink-0" @size={{20}} />
            <span class="text-sm">{{t "strategy_finder_0726.what_next.recertify"}}</span>
          </li>
          <li class="tio-row gap-2 items-start">
            <PhCheckCircle class="tio-fg-success shrink-0" @size={{20}} />
            <span class="text-sm">{{t "strategy_finder_0726.what_next.monitor"}}</span>
          </li>
        </ul>
        <Button @intent="primary" {{on "click" this.goToForm}}>
          {{t "strategy_finder_0726.what_next.cta"}}
        </Button>
      </:body>
    </Section>
  </template>
}
